"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 *
 *
 * @param {Recover} recover A reference to the Recover class
 * @class DebtStatusCounts
 * @classdesc Is used to return a count for all Debt status
 */
var DebtStatusCounts = /** @class */ (function () {
    function DebtStatusCounts(recover) {
        var _this = this;
        this.recover = recover;
        /**
         *
         *
         * @memberof DebtStatusCounts
         * @returns {ISuccessfulGetDebtStatusCountsResponse} Returns a message and an object containing every status and how many debts are in each status.
         * @description Returns a list of values for each status
         */
        this.get = function () {
            return _this.recover.request("/debt_status_counts", "GET", null, null);
        };
    }
    return DebtStatusCounts;
}());
exports.default = DebtStatusCounts;
